import type { CartItem } from "../types/cart.types";

export interface CartItemAddedEvent {
    type: "ITEM_ADDED";
    item: CartItem;
}

export type CartEvent = CartItemAddedEvent;
export type CartEventListener = (event: CartEvent) => void;

const listeners = new Map<string, CartEventListener>();

export function subscribeToCartEvents(
    subscriberId: string,
    listener: CartEventListener,
): () => void {
    listeners.set(subscriberId, listener);

    return () => {
        if (listeners.get(subscriberId) === listener) listeners.delete(subscriberId);
    };
}

export function emitCartEvent(event: CartEvent): void {
    listeners.forEach((listener) => {
        try {
            listener(event);
        } catch {
            // Secondary observers must never interrupt a cart mutation.
        }
    });
}
